var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_121_8184",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 101
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50.5,
    r: 50.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_121_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.2141 78.1475L67.1375 68.3479L72.8215 57.9272C74.1466 55.4937 74.8418 52.7673 74.8438 49.9965V33.5C74.8438 27.3503 72.4008 21.4525 68.0523 17.104C63.7038 12.7555 57.806 10.3125 51.6563 10.3125C45.5066 10.3125 39.6087 12.7555 35.2602 17.104C30.9117 21.4525 28.4688 27.3503 28.4688 33.5V49.9965C28.4708 52.7674 29.166 55.4938 30.4911 57.9274L36.1751 68.3479L21.0985 78.1475C18.7814 79.6475 16.8775 81.7046 15.5609 84.1307C14.2444 86.5567 13.5573 89.2741 13.5625 92.0344V109.688H89.7501V92.0344C89.7552 89.2741 89.0681 86.5567 87.7516 84.1307C86.4351 81.7047 84.5312 79.6475 82.2141 78.1475ZM83.1251 103.062H20.1875V92.0344C20.1844 90.3782 20.5967 88.7477 21.3867 87.2921C22.1766 85.8364 23.319 84.6022 24.7093 83.7022L44.928 70.56L36.3072 54.7551C35.5122 53.2949 35.0951 51.659 35.0938 49.9965V33.5C35.0938 29.1074 36.8388 24.8946 39.9448 21.7885C43.0509 18.6825 47.2636 16.9375 51.6563 16.9375C56.0489 16.9375 60.2617 18.6825 63.3677 21.7885C66.4738 24.8946 68.2188 29.1074 68.2188 33.5V49.9965C68.2175 51.659 67.8004 53.2949 67.0054 54.7551L58.3848 70.56L78.6039 83.7022C79.9941 84.6022 81.1363 85.8365 81.9262 87.2922C82.716 88.7478 83.1282 90.3783 83.1251 92.0344V103.062Z",
    fill: "#C5C8CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.db1e589f2999eb3bc59ef55d7ab4015e.svg";
export { ForwardRef as ReactComponent };